import TextWithIcon from '../../../TextWithIcon';
export default TextWithIcon;